module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"outbound":"Utgående EDI","inbound":"Inngående EDI"},"en":{"outbound":"Outbound EDI","inbound":"Inbound EDI"}}')
  delete Component.options._Ctor
}
